import { useSuspenseQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../constants/queryKeys'
import userService from '../../../lib/services/userService'

export function useBannerNotificationQuery() {
  return useSuspenseQuery({
    queryKey: QUERY_KEYS.bannerNotification(),
    queryFn: () => userService.getBannerNotification(),
  })
}
